"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnqDivider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var prefixCls = 'anq-divider';
var AnqDivider = function (props) {
    var _a;
    var children = props.children, _b = props.orientation, orientation = _b === void 0 ? 'center' : _b, _c = props.type, type = _c === void 0 ? 'horizontal' : _c, dashed = props.dashed, className = props.className, _d = props.style, ownStyle = _d === void 0 ? {} : _d;
    var hasChildren = !!children;
    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
    var classString = (0, classnames_1.default)(prefixCls, "".concat(prefixCls, "-").concat(type), (_a = {},
        _a["".concat(prefixCls, "-with-text")] = hasChildren,
        _a["".concat(prefixCls, "-with-text").concat(orientationPrefix)] = hasChildren,
        _a["".concat(prefixCls, "-dashed")] = !!dashed,
        _a), className);
    return (react_1.default.createElement("div", { className: classString, style: ownStyle }, children && react_1.default.createElement("span", { className: "".concat(prefixCls, "-inner-text") }, children)));
};
exports.AnqDivider = AnqDivider;
exports.default = AnqDivider;
//# sourceMappingURL=index.js.map